'use strict';

/**
 * @function
 * @description Set the location hash
 * @param {String} hash The location hash
 */
const setLocationHash = (hash) => {
    if (!hash || hash.length === 0) {
        return;
    }

    window.location.hash = '#' + hash;
};

module.exports = setLocationHash;
